import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Filter"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.5 21H10.5C9.67157 21 9 20.3284 9 19.5V13.8075L3.4425 8.25C3.16081 7.96999 3.00167 7.58968 3 7.1925V4.5C3 3.67157 3.67157 3 4.5 3H19.5C20.3284 3 21 3.67157 21 4.5V7.1925C20.9983 7.58968 20.8392 7.96999 20.5575 8.25L15 13.8075V19.5C15 20.3284 14.3284 21 13.5 21ZM4.5 4.5V7.1925L10.5 13.1925V19.5H13.5V13.1925L19.5 7.1925V4.5H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Filter.vue"]]);
